// Shared step names of the Stratodata Stairway (6 levels of data maturity).
// Used on /our-work/data (Data Maturity) and /our-work/data-engineering (Data Warehousing).
// Keep the Slovak names identical to the ones used on /how-it-works.

const en = {
  /** Full step names, index 0 = level 1. */
  stepNames: [
    'Excel Age',
    'Data Silos',
    'Single Source of Truth',
    'Data-Driven Culture',
    'Scaled Automation',
    'AI-Powered Enterprise',
  ],
  /** Short labels used in the mini stairway on Data Warehousing (level 6 is shortened). */
  stepNamesShort: [
    'Excel Age',
    'Data Silos',
    'Single Source of Truth',
    'Data-Driven Culture',
    'Scaled Automation',
    'AI-Powered',
  ],
};

const sk: typeof en = {
  stepNames: [
    'Éra Excelu',
    'Dátové silá',
    'Jeden zdroj pravdy',
    'Dátová kultúra',
    'Automatizácia vo veľkom',
    'Firma poháňaná AI',
  ],
  stepNamesShort: [
    'Éra Excelu',
    'Dátové silá',
    'Jeden zdroj pravdy',
    'Dátová kultúra',
    'Automatizácia vo veľkom',
    'Poháňaná AI',
  ],
};

export const stairwayCopy = { en, sk };
